/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

#card-injury-location {
  .table {
    display: flex;
    flex-direction: column;
    @include mixins.use-available-space;

    .table-header {
      display: flex;
      flex-direction: row;

      h6 {
        width: auto;
        min-width: 60px;
      }
    }

    div.col-location {
      min-width: 100px;
      width: 25%;
    }

    div.col-severity {
      width: 100%;
      display: flex;
      justify-content: space-around;
    }

    div.col-state {
      min-width: 120px;
      display: flex;
      width: 25%;
      justify-content: space-around;

      .radios {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        label {
          margin: 0;
        }
      }
    }

    .table-body .row {
      display: flex;
      align-items: center;
      border-bottom: 1px solid variables.$color-corpuls-secondary-50;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  hr {
    margin: 0 30px;
  }

  .col-polytrauma {
    width: auto;
    min-width: 130px;
  }
}
